import { render, staticRenderFns } from "./UserPasswordResetDialog.vue?vue&type=template&id=91a575a8&scoped=true"
import script from "./UserPasswordResetDialog.vue?vue&type=script&lang=js"
export * from "./UserPasswordResetDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPasswordResetDialog.vue?vue&type=style&index=0&id=91a575a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a575a8",
  null
  
)

export default component.exports